import { Node } from "@p0security/shared/graph/types";
import { AssessmentNodes } from "@p0security/shared/types/assessment/data/index";
import { Typography } from "antd";
import { GraphTooltip } from "components/GraphTooltip";
import { capitalize } from "lodash";
import { assertNever } from "utils/assert";

import { CellInner } from "./Inner";

const { Text } = Typography;

export const Lateral: React.FC<{ node: Node<AssessmentNodes, "lateral"> }> = ({
  node,
}) => {
  const { data } = node;

  const label =
    data.type === "grant"
      ? "direct impersonation"
      : data.type === "resource"
        ? "service identity"
        : assertNever(data.type);

  return (
    <GraphTooltip
      width="300px"
      title={
        <div>
          <div>Lateral movement via {label}</div>
          <div>
            Service: <Text code>{data.service}</Text>
          </div>
          {data.resources.length === 1 ? (
            <div>
              Resource: <Text code>{data.resources[0]} </Text>{" "}
            </div>
          ) : (
            <div>{data.resources.length} Resources </div>
          )}
        </div>
      }
    >
      <div>{capitalize(label)}</div>

      <CellInner style={{ paddingLeft: "8px" }}>
        <span>→</span>
        <span style={{ fontStyle: "italic", paddingLeft: "4px" }}>
          {data.identity}
        </span>
      </CellInner>
    </GraphTooltip>
  );
};
